export interface CustomerName {
	customerId: number;
	customerName: string;
	publicDisplayName?: string;
}

export default interface Customer extends CustomerName {
	addressLine1: string;
	addressLine2: string;
	deactivated?: boolean;
	town: string;
	county: string;
	postalCode: string;
	billingTypeId?: number;
	deleted?: boolean;
	currencyISOCode: string;
	currencyCode?: string;
	billingFrequencyId?: number;
	// eslint-disable-next-line camelcase
	cC_LastFourDigits?: string;
	// eslint-disable-next-line camelcase
	cC_Expiry?: string;
	// eslint-disable-next-line camelcase
	cC_BillingAgentReference?: string;
	// eslint-disable-next-line camelcase
	cC_BillingCardReference?: string;
	billingDetailStatusName?: string;
	firstName?: string;
	lastName?: string;
	emailAddress?: string;
	phoneNumber?: string;
	taxDescription?: string;
	parentId?: number;
	productId: ProductId;
	productCode?: ProductCode;
	productName?: string;
	countryISOCode: string;
	emailNotification: boolean;
	paymentOverdue: boolean;
	dbsOrgShortCode?: string;
	emailNotificationToSupport?: boolean;
	officeCode: string;
	customerBrandingProperties?: string | null;
	reportType: number;
	billingUserId?: number;
	contactId: string;
	childCustomer?: Customer[];
	twoFactorAuthenticationEnabled: boolean;
	sector: string;
	accountExecutive: string;
	brandingName?: string;
	ssoType?: string;
	ssoProperties?: string;
	packageCompletionNotification?: boolean;
	retentionPeriodUnit?: string;
	retentionPeriodValue?: number;
	removalAction?: string;
	notificationBannerText?: string | null;
	resolvedNotificationBannerText?: string | null;
}

export interface RootCustomer {
	customerId: number;
	customerName: string;
	emailAddress: string;
	phoneNumber: string;
	customerBrandingProperties?: string | null;
	website: string;
	abn: string;
}

// eslint-disable-next-line no-shadow
export enum ProductCode {
	Basic = 'VB',
	Professional = 'VP',
	Enterprise = 'VE'
}

// eslint-disable-next-line no-shadow
export enum ProductId {
	Basic = 1,
	Professional = 6,
	Enterprise = 7
}

// eslint-disable-next-line no-shadow
export enum BillingTypes {
	Parent = 5,
	Branch = 6
}

// eslint-disable-next-line no-shadow
export enum FeeFrequency {
	OneOff = 'One Off',
	Annual = 'Annual',
	Monthly = 'Monthly'
}

// eslint-disable-next-line no-shadow
export enum RemovalActionTypes {
	AutoScrub = 'Auto-Scrub',
	AutoDelete = 'Auto-Delete'
}

// eslint-disable-next-line no-shadow
export enum EmploymentSector {
	AcademyEducation = 'ACADEMY EDUCATION',
	AccommodationAndFoodService = 'ACCOMMODATION AND FOOD SERVICE',
	AdministrativeAndSupport = 'ADMINISTRATIVE AND SUPPORT',
	AgricultureAndFishing = 'AGRICULTURE, FORESTRY AND FISHING',
	ArtsAndEntertainment = 'ARTS AND ENTERTAINMENT',
	CentralGovernment = 'CENTRAL GOVERNMENT',
	ChildCare = 'CHILD CARE',
	Construction = 'CONSTRUCTION',
	Drivers = 'DRIVERS',
	EnergyAndConditioning = 'ENERGY AND AIR CONDITIONING',
	FinancialAndInsurance = 'FINANCIAL AND INSURANCE',
	FosterAdoption = 'FOSTER/ADOPTION',
	FurtherEducation = 'FURTHER EDUCATION',
	HigherEducation = 'HIGHER EDUCATION',
	IndependentEducation = 'INDEPENDENT EDUCATION',
	InformationAndCommunication = 'INFORMATION AND COMMUNICATION',
	LawEnforcementAndSecurity = 'LAW ENFORCEMENT AND SECURITY',
	LeisureAndSports = 'LEISURE, SPORT AND TOURISM',
	LocalGovernment = 'LOCAL GOVERNMENT',
	Manufacturing = 'MANUFACTURING',
	Mining = 'MINING AND QUARRYING',
	NHS = 'NHS',
	PreschoolEducation = 'PRESCHOOL EDUCATION',
	PrimaryEducation = 'PRIMARY EDUCATION',
	PrivateHealthCare = 'PRIVATE HEALTHCARE',
	Professional = 'PROFESSIONAL, TECHNICAL',
	PublicSector = 'PUBLIC SECTOR - OTHER',
	RealEstateActivities = 'REAL ESTATE ACTIVITIES',
	RecruitmentAndHr = 'RECRUITMENT AND HR',
	Retail = 'RETAIL',
	SecondaryEducation = 'SECONDARY EDUCATION',
	SocialCare = 'SOCIAL CARE',
	TradeVehicles = 'TRADE OR REPAIR OF VEHICLES',
	TransportationAndStorage = 'TRANSPORTATION AND STORAGE',
	VoluntaryCharity = 'VOLUNTARY/CHARITY',
	WaterAndWasteManagement = 'WATER AND WASTE MANAGEMENT'
}

export interface Registration {
	customerName: string;
	publicDisplayName?: string;
	addressLine1: string;
	addressLine2: string;
	deactivated?: boolean;
	town: string;
	county: string;
	postalCode: string;
	billingTypeId?: number;
	deleted?: boolean;
	currencyISOCode: string;
	countryISOCode: string;
	currencyCode: string;
	billingDetailStatusName?: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phoneNumber: string;
}

export interface CustomerCheckCategory {
	id: string;
	customerId: number;
	categoryName: string;
	checkType: string;
	properties: string;
	lastUpdated: string;
	lastUpdatedBy: string;
}

export interface CreateCustomerCheckCategoryRequest {
	customerId: number;
	categoryName: string;
	checkType: string;
	properties: string;
	lastUpdatedBy: string;
}

export interface UpdateCustomerCheckCategoryRequest extends CreateCustomerCheckCategoryRequest {
	id: string;
	lastUpdated: string;
}
